module.exports = __webpack_public_path__ + "img/stick_divers_voiture.a0787be8.svg";